var $ = jQuery;
var strCurrentSearch = '';
var request;
// Autocomplete when you enter something in search box header
$(document).ready(function () {
    // Autocomplete when you enter something in search box header
    var Timer;

    /*$('.search input#txtSearch').keyup(function (e) {
        clearTimeout(Timer);

        if (e.which == 13) {
            request.abort();
        }

        if ($(this).val().length >= 3 && e.which != 13) {
            strCurrentSearch = $(this).val();

            Timer = setTimeout(
                (function (opts) {
                    return function () {
                        AutoSearch(opts);
                    };
                })($(this).val()), 400);
        } else {
            $('header div.suggestion').addClass('d-none');
        }
    });*/

    $("select[name='type']").change(function () {
        $("input#txtSearch").attr("placeholder", strLabelSearching + " " + $("select[name='type'] option:selected").text().toLowerCase());
    });

    $('aside').on('keyup', '.filters input[type=\'text\']', function (e) {
        clearTimeout(Timer);

        if ($(this).val().length >= 1) {
            var strSearch = $(this).val();
            var intFilter = $(this).attr('data-filter');
            var strProductsFull = $('input#strProductsFull').val();
            var strSelectedFilters = $('input#strSelectedFilters').val();

            Timer = setTimeout(
                (function (opts) {
                    return function () {
                        LoadFilter(opts);
                    };
                })({strSearch, intFilter, strProductsFull, strSelectedFilters}), 400);
        } else {
            $(this).closest('div.filters').find('div.filter-search').remove();
            $(this).closest('div.filters').find('div.filter-scroll').removeClass('d-none');
        }
    });


    /*$('aside').on('focus keyup', '.filters input[type=\'text\']', function (e) {
        clearTimeout(Timer);

        if (!$(this)[0].hasAttribute("readonly") && e.which != 13) {
            var strSearch = $(this).val();
            var intFilter = $(this).attr('data-filter');
            var strType = $(this).attr('data-type');
            var strProductsFull = $('input#strProductsFull').val();
            var strGET = $('input#strGET').val();
            var objSearch = $('input[data-filter=\'' + intFilter + '\']');
            var objAutoComplete = $('div.autocomplete[data-filter=\'' + intFilter + '\']');

            if (objSearch.val() != objSearch.attr('data-search')) {
                Timer = setTimeout(
                    (function (opts) {
                        return function () {
                            SearchFilter(opts);
                        };
                    })({strSearch, intFilter, strType, intCategoryNo, strProductsFull, strGET}), 400);
            } else {
                $('div.filters div.autocomplete').hide();
                objAutoComplete.show();
            }
        }
    });

    $('aside').on('click', '.filters button.remove', function (e) {
        var strValue = $(this).closest('div.filters').find("input[type='text']").val();
        var strNewUrl = $('div.selected-filters a[data-filter="' + strValue + '"]').attr("href");
        window.history.pushState({path: strNewUrl}, '', strNewUrl);

        //-- Clear value
        $(this).closest('div.filters').find('input[type=text]').val('');
        $(this).closest('div.filters').find('input[type=text]').removeAttr('readonly');
        $(this).closest('div.filters').find('button i').attr('class', 'fal fa-search');
        $("div.filters input[type='text']").removeAttr('data-search');

        //--Hide clear all
        var blnHideClearAll = true;
        $('div.filters').each(function () {
            var objItem = $(this);
            if (objItem.find("input[type='text']").val() != "") {
                blnHideClearAll = false;
            }
        });

        if (blnHideClearAll === true) {
            $("a.clearall").removeClass('d-block').addClass('d-none');
        }

        // Load articles
        LoadArticlesWithoutFilters();

        // Scroll to top catalog overview
        $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
        return false;
    });*/
});


// Hide search suggestion when you don't click on it
$(document).mouseup(function (e) {
    var container = $('header div.suggestion');
    //var autocomplete = $('div.filters div.autocomplete');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.addClass('d-none');
    }

    /*if (!autocomplete.is(e.target) && !autocomplete.closest('div.filters').find("input[type='text']").is(e.target) && autocomplete.has(e.target).length === 0) {
        autocomplete.hide();
        autocomplete.closest('div.filters').find('button i').attr('class', 'fal fa-search');
    }*/
});

// Autosuggestion search
function AutoSearch(strSearch) {
    if (strSearch == undefined) {
        strSearch = '';
    }
    var strTempSearch = $('header input#txtSearch').val();
    $('.search [class*=\'btn-search\']').removeClass('fa fa-search').addClass('fas fa-spinner fa-spin');
    if (strSearch == strCurrentSearch) {
        // Get autocomplete search
        if (request) {
            request.abort();
        }
        request = $.post(strAjaxPath + 'search-suggest.php', $('form.search').serialize(), function (data) {
            if (strTempSearch == $('header input#txtSearch').val()) {
                if (data != '') {
                    $('.search [class*=\'btn-search\']').addClass('fa fa-search').removeClass('fas fa-spinner fa-spin');
                    $('header div.suggestion').html(data);
                    $('header div.suggestion').removeClass('d-none');
                } else {
                    $('header div.suggestion').addClass('d-none');
                    $('.search [class*=\'btn-search\']').addClass('fa fa-search').removeClass('fas fa-spinner fa-spin');
                }

                // Clicking on a link after 'Bedoelde u' in suggestion
                $('header div.suggestion div.suggest a.suggest').click(function () {
                    // If the suggestion is the name/description/... from a product => search on that suggestion
                    // (If the suggestion is a categoryname, then there's a href => go to that href)
                    if ($(this).attr('href') == '#') {
                        $('header input#txtSearch').val($(this).find('strong').html());
                        $('header form.search').submit();
                    }
                });
            }

            // Link 'See all results' in search autocomplete header
            $('header div.suggestion a.view-all').click(function () {
                $(this).closest('form').submit();
                return false;
            });
        }, 'html');
    }
}

// Filter search
/*function SearchFilter(objOptions) {
    var objSearch = $('input[data-filter=\'' + objOptions.intFilter + '\']');
    var objAutoComplete = $('div.autocomplete[data-filter=\'' + objOptions.intFilter + '\']');

    //--Set load icon
    objSearch.closest('div.filters').find('button i').attr('class', 'fas fa-spinner fa-spin');

    //--Save search temp
    objSearch.attr('data-search', objSearch.val());

    //--Remove autocomplete
    objAutoComplete.remove();

    $.post(strAjaxPath + 'search-filter.php', objOptions, function (data) {
        if (data != '') {
            //--Reset search icon + add autocomplete div
            objSearch.closest('div.filters').find('button i').attr('class', 'fal fa-search');
            objSearch.closest('div.filters').find("div.input-group").after("<div class='autocomplete overflow-auto border bg-white p-1' data-filter='" + objOptions.intFilter + "'></div>");

            //--Add suggest items
            $.each(data.values, function (i, item) {
                $("div.autocomplete[data-filter='" + objOptions.intFilter + "']").append("<a class='d-block position-relative' rel='nofollow' href='" + item.href + "'>" + item.name + "</a>");
            });

            $("div.autocomplete a").click(function () {
                //--Reset icon + addclass remove + make search readonly + change value with filtername
                $(this).closest('div.filters').find('button i').attr('class', 'fal fa-times');
                $(this).closest('div.filters').find('button').addClass('remove');
                $(this).closest('div.filters').find('input[type="text"]').attr("readonly", "readonly");
                $(this).closest('div.filters').find('input[type="text"]').val($(this).text());

                //--Show reset all link + clear search
                $("a.clearall").removeClass('d-none').addClass('d-block');
                $("div.filters input[type='text']").removeAttr('data-search');

                //--Remove suggest
                $('div.autocomplete[data-filter=\'' + objOptions.intFilter + '\']').remove();

                return false;
            });
        } else {
            //--Reset icon search
            objSearch.closest('div.filters').find('button i').attr('class', 'fal fa-search');

            //--Remove suggest
            objAutoComplete.remove();
        }

        InitFilters();
    }, 'json');
}*/

// Filter search
function LoadFilter(objOptions) {
    var objSearch = $('input[data-filter=\'' + objOptions.intFilter + '\']');
    objSearch.closest('div.filters').find('button i').attr('class', 'fas fa-spinner fa-spin');
    $.post(strAjaxPath + 'load-filter.php', objOptions, function (data) {
        if (data != '') {
            $('div.filter-scroll[data-filter=\'' + objOptions.intFilter + '\']').addClass('d-none');
            objSearch.closest('div.filters').find('div.filter-search').remove();
            objSearch.closest('div.filters').append(data);
        } else {
            objSearch.closest('div.filters').find('div.filter-scroll').removeClass('d-none');
            objSearch.closest('div.filters').find('div.filter-search').remove();
        }
        objSearch.closest('div.filters').find('button i').attr('class', 'fal fa-search');

        InitFilters();
    }, 'html');
}